/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  InputWithLabel,
  SelectWithLabel,
  TextAreaWithLabel
} from '@adotel/components'
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Chip,
  Divider
} from '@material-ui/core'

import CustomCounter from '../../../../components/CustomCounter'
import { getTranslate } from '../../../../localization'
import { ModifyReservationInput } from '../../../../types/modifyReserveTAPanel'
import { useStyles } from './styles/index.styles'

type ProfileFormProps = {
  modifyReservationInput: ModifyReservationInput
  setModifyReservationInput: React.Dispatch<
    React.SetStateAction<ModifyReservationInput>
  >
  roomIndex: number
  profileIndex: number
  disabled: boolean
}
const ProfileForm = ({
  modifyReservationInput,
  setModifyReservationInput,
  roomIndex,
  profileIndex,
  disabled
}: ProfileFormProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <InputWithLabel
          label={getTranslate('First Name')}
          disabled={disabled}
          value={
            modifyReservationInput?.roomStays?.[roomIndex]?.profiles?.[
              profileIndex
            ]?.firstName ?? ''
          }
          onChange={(event) => {
            setModifyReservationInput({
              ...modifyReservationInput,
              roomStays: [
                ...modifyReservationInput.roomStays.slice(0, roomIndex),
                {
                  ...modifyReservationInput.roomStays[roomIndex],
                  profiles: [
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(0, profileIndex),
                    {
                      ...modifyReservationInput.roomStays[roomIndex].profiles[
                        profileIndex
                      ],
                      firstName: event.currentTarget.value
                    },
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(profileIndex + 1)
                  ]
                },
                ...modifyReservationInput.roomStays.slice(roomIndex + 1)
              ]
            })
          }}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('Last Name')}
          disabled={disabled}
          value={
            modifyReservationInput?.roomStays?.[roomIndex]?.profiles?.[
              profileIndex
            ]?.lastName ?? ''
          }
          className={classes.input}
          onChange={(event) => {
            setModifyReservationInput({
              ...modifyReservationInput,
              roomStays: [
                ...modifyReservationInput.roomStays.slice(0, roomIndex),
                {
                  ...modifyReservationInput.roomStays[roomIndex],
                  profiles: [
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(0, profileIndex),
                    {
                      ...modifyReservationInput.roomStays[roomIndex].profiles[
                        profileIndex
                      ],
                      lastName: event.currentTarget.value
                    },
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(profileIndex + 1)
                  ]
                },
                ...modifyReservationInput.roomStays.slice(roomIndex + 1)
              ]
            })
          }}
        />
        <InputWithLabel
          label={getTranslate('Email')}
          disabled={disabled}
          value={
            modifyReservationInput?.roomStays?.[roomIndex]?.profiles?.[
              profileIndex
            ]?.email ?? ''
          }
          className={classes.input}
          onChange={(event) => {
            setModifyReservationInput({
              ...modifyReservationInput,
              roomStays: [
                ...modifyReservationInput.roomStays.slice(0, roomIndex),
                {
                  ...modifyReservationInput.roomStays[roomIndex],
                  profiles: [
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(0, profileIndex),
                    {
                      ...modifyReservationInput.roomStays[roomIndex].profiles[
                        profileIndex
                      ],
                      email: event.currentTarget.value
                    },
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(profileIndex + 1)
                  ]
                },
                ...modifyReservationInput.roomStays.slice(roomIndex + 1)
              ]
            })
          }}
        />
      </div>
      <div className={classes.row}>
        <InputWithLabel
          label={getTranslate('Phone Number')}
          disabled={disabled}
          value={
            modifyReservationInput?.roomStays?.[roomIndex]?.profiles?.[
              profileIndex
            ]?.phone ?? ''
          }
          className={classes.input}
          onChange={(event) => {
            setModifyReservationInput({
              ...modifyReservationInput,
              roomStays: [
                ...modifyReservationInput.roomStays.slice(0, roomIndex),
                {
                  ...modifyReservationInput.roomStays[roomIndex],
                  profiles: [
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(0, profileIndex),
                    {
                      ...modifyReservationInput.roomStays[roomIndex].profiles[
                        profileIndex
                      ],
                      phone: event.currentTarget.value
                    },
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(profileIndex + 1)
                  ]
                },
                ...modifyReservationInput.roomStays.slice(roomIndex + 1)
              ]
            })
          }}
        />
        <InputWithLabel
          label={getTranslate('Identification Number')}
          disabled={disabled}
          value={
            modifyReservationInput?.roomStays?.[roomIndex]?.profiles?.[
              profileIndex
            ]?.identificationNo ?? ''
          }
          className={classes.input}
          onChange={(event) => {
            setModifyReservationInput({
              ...modifyReservationInput,
              roomStays: [
                ...modifyReservationInput.roomStays.slice(0, roomIndex),
                {
                  ...modifyReservationInput.roomStays[roomIndex],
                  profiles: [
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(0, profileIndex),
                    {
                      ...modifyReservationInput.roomStays[roomIndex].profiles[
                        profileIndex
                      ],
                      identificationNo: event.currentTarget.value
                    },
                    ...modifyReservationInput.roomStays[
                      roomIndex
                    ].profiles.slice(profileIndex + 1)
                  ]
                },
                ...modifyReservationInput.roomStays.slice(roomIndex + 1)
              ]
            })
          }}
        />
      </div>
      <RadioGroup
        row
        aria-disabled={disabled}
        value={
          modifyReservationInput?.roomStays?.[roomIndex]?.profiles?.[
            profileIndex
          ]
            ? modifyReservationInput.roomStays[roomIndex].profiles[profileIndex]
                .isForeigner
              ? 'Foreign'
              : 'Iranian'
            : ''
        }
        onChange={(event) => {
          const isForeign = event.target.value === 'Foreign'
          setModifyReservationInput({
            ...modifyReservationInput,
            roomStays: [
              ...modifyReservationInput.roomStays.slice(0, roomIndex),
              {
                ...modifyReservationInput.roomStays[roomIndex],
                profiles: [
                  ...modifyReservationInput.roomStays[roomIndex].profiles.slice(
                    0,
                    profileIndex
                  ),
                  {
                    ...modifyReservationInput.roomStays[roomIndex].profiles[
                      profileIndex
                    ],
                    isForeigner: isForeign
                  },
                  ...modifyReservationInput.roomStays[roomIndex].profiles.slice(
                    profileIndex + 1
                  )
                ]
              },
              ...modifyReservationInput.roomStays.slice(roomIndex + 1)
            ]
          })
        }}>
        <FormControlLabel
          value={'Iranian'}
          control={
            <Radio
              color="primary"
              disabled={disabled}
              classes={{
                root: classes.radioIcon
              }}
            />
          }
          label={getTranslate('Iranian Guest')}
          classes={{ label: classes.label }}
        />
        <FormControlLabel
          value="Foreign"
          control={
            <Radio
              color="primary"
              disabled={disabled}
              classes={{
                root: classes.radioIcon
              }}
            />
          }
          label={getTranslate('Foreign Guest')}
          classes={{ label: classes.label }}
        />
      </RadioGroup>
      <TextAreaWithLabel
        label={getTranslate('Description')}
        rows={5}
        disabled={disabled}
      />
      {/* , */}
    </div>
  )
}

export default ProfileForm
